import { validate as uuidValidate, v4 as uuidv4, v5 as uuidv5 } from "uuid";
import type { PlainDate } from "./types";

/**
 * Namespace проекта для детерминированных uuid v5.
 *
 * ЗАФИКСИРОВАН НАВСЕГДА. От него считаются id всех системных и day-нод; оффлайн-клиент
 * вычисляет их без сети и сразу вешает детей на нужного родителя (offline-sync §8).
 * Смена namespace = вся история дней и системные якоря уезжают на новые id, а существующие
 * ноды остаются сиротами. Менять нельзя после первого сида — никогда.
 */
export const MAPCRAFT_NAMESPACE = "6b2f7c3e-9a41-5d8b-b0d6-1f5a2c7e4d90";

/** Системные ноды-синглтоны, у которых id детерминирован. `day` — отдельно, он от даты. */
export const SYSTEM_NODE_KEYS = ["root", "calendar", "inbox", "pinned"] as const;
export type SystemNodeKey = (typeof SYSTEM_NODE_KEYS)[number];

export function systemNodeId(key: SystemNodeKey): string {
	return uuidv5(`system:${key}`, MAPCRAFT_NAMESPACE);
}

/** id day-ноды считается из даты — и на сервере, и оффлайн, одинаково. */
export function dayNodeId(date: PlainDate): string {
	return uuidv5(`day:${date}`, MAPCRAFT_NAMESPACE);
}

export const SYSTEM_NODE_IDS: Record<SystemNodeKey, string> = {
	root: systemNodeId("root"),
	calendar: systemNodeId("calendar"),
	inbox: systemNodeId("inbox"),
	pinned: systemNodeId("pinned")
};

/**
 * id оформления тега считается из ИМЕНИ: цвет ставят оффлайн с двух устройств, и обе
 * записи обязаны попасть в одну строку, а не завести две. Имя — уже нормализованное.
 */
export function tagId(name: string): string {
	return uuidv5(`tag:${name}`, MAPCRAFT_NAMESPACE);
}

/** Обычные ноды получают обычный v4, сгенерированный клиентом. */
export function newNodeId(): string {
	return uuidv4();
}

export function isUuid(value: string): boolean {
	return uuidValidate(value);
}
